<template>
  <div id="app">
    <keep-alive>
      <router-view ref="child" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view ref="child" v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
  export default {
    name: "App",
    data() {
      return {
      }
    },
  };
</script>
<style>
  body{
    margin: 0;
    padding: 0;
    outline: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    background: #f0f2f5;
    --activeColor: #409EFF;
    --activeBGColor: rgba(64,158,255,.08);
  }
  #app{
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue